const SELECT = 'id,subject,bodyPreview,receivedDateTime,internetMessageId,from,conversationId,categories';
async function fetchMessages(url, accessToken) {
    const res = await fetch(url, {
        headers: {
            Authorization: `Bearer ${accessToken}`,
            Accept: 'application/json',
        },
    });
    if (!res.ok) {
        const text = await res.text();
        throw new Error(`Graph API ${res.status}: ${text}`);
    }
    const data = (await res.json());
    return data.value || [];
}
/**
 * Load Outlook Inbox messages for the signed-in user.
 * Tries mailFolders/inbox first, then /me/messages as fallback.
 */
export async function fetchInboxMessages(accessToken) {
    const params = new URLSearchParams({
        $top: '50',
        $orderby: 'receivedDateTime desc',
        $select: SELECT,
    });
    const inboxUrl = `https://graph.microsoft.com/v1.0/me/mailFolders/inbox/messages?${params}`;
    try {
        const inbox = await fetchMessages(inboxUrl, accessToken);
        if (inbox.length > 0)
            return inbox;
    }
    catch (err) {
        console.warn('[graph] inbox folder fetch failed — trying /me/messages', err);
    }
    const allUrl = `https://graph.microsoft.com/v1.0/me/messages?${params}`;
    return fetchMessages(allUrl, accessToken);
}
